module.exports = __webpack_public_path__ + "img/assess_paint.ad6987f4.svg";